import type {
  ICommonModelProperty,
  IModelProperty,
} from '@fulcrum/cdm-components';

// bigint = (high * 2^32 + low)
// eslint-disable-next-line no-magic-numbers -- Split bigint into 32-bit chunks
const deprecatedLongHighShift = BigInt(32);
// eslint-disable-next-line no-magic-numbers -- Mask low 32 bits
const deprecatedLongLowMask = BigInt(0xffffffff);

export function convertCommonModelValueToPanelValue(
  value: string | number | bigint | null | undefined
): ICommonModelProperty['displayProperty']['value'] {
  if (value === null) {
    // cdm-components docs allow null for mixed common values, though typings still omit it.
    return null as unknown as ICommonModelProperty['displayProperty']['value'];
  }
  return convertModelValueToPanelValue(value);
}

export function convertModelValueToPanelValue(
  value: string | number | bigint | undefined
): IModelProperty['value'] {
  if (value === undefined) {
    return '';
  }
  return typeof value === 'bigint' ? bigintToDeprecatedLong(value) : value;
}

export function bigintToDeprecatedLong(
  value: bigint
): Extract<IModelProperty['value'], { high: number; low: number }> {
  return {
    high: Number(value >> deprecatedLongHighShift),
    low: Number(value & deprecatedLongLowMask),
  };
}
